<template>
  <details class="forum-next-page-menu" @keydown.esc.prevent.stop="close(true)">
    <summary ref="toggle" aria-label="Más opciones del foro" title="Más opciones del foro"><i class="pi pi-ellipsis-h" aria-hidden="true"></i></summary>
    <nav aria-label="Más opciones del foro">
      <router-link :to="{ name: 'ForumNextRules' }" @click.native="close(false)">Normas del foro</router-link>
      <router-link v-if="canModerate" class="forum-next-admin-link" :to="{ name: 'ForumNextPending' }" @click.native="close(false)">Pendientes</router-link>
    </nav>
  </details>
</template>
<script>
export default {
  name: 'ForumPageMenu',
  props: { canModerate: Boolean },
  watch: { '$route.fullPath'() { this.close(false); } },
  mounted() { document.addEventListener('pointerdown', this.onOutside); },
  beforeDestroy() { document.removeEventListener('pointerdown', this.onOutside); },
  methods: {
    close(restoreFocus) { if (!this.$el.open) return; this.$el.open = false; if (restoreFocus) this.$refs.toggle.focus(); },
    onOutside(event) { if (!this.$el.contains(event.target)) this.close(false); }
  }
};
</script>
